import { render, staticRenderFns } from "./PayrollForm.vue?vue&type=template&id=3257e220&"
import script from "./PayrollForm.vue?vue&type=script&lang=js&"
export * from "./PayrollForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports